import { locationStore } from "@root/stores";
import { action } from "mobx";

export class FinishedUIStore {
  @action
  public onNavigationClicked = () => {
    locationStore.pushAppList();
  };
}
